import { historySummary, selectedHistory, measured } from "./teamAnalysis";
import { FEATURES, hasFeatureAccess } from "./featureAccess";
export const canUseTeamWorkspace = (user) =>
  !!user && hasFeatureAccess(FEATURES.TEAM_LEAGUE_WORKSPACE, user);
export const comparisonSources = [
  "should",
  "result",
  "real",
  "statistics",
  "market",
];
export function comparableHistory(
  observations,
  id,
  sources,
  { recent = false, venue = "all" } = {}
) {
  const selected = selectedHistory(observations, id, false).filter(
    (f) => venue === "all" || f[venue + "_team_id"] === Number(id)
  );
  const games = recent ? selected.slice(0, recent) : selected;
  const ids = sources.map(
    (source) => new Set(historySummary(games, id, source).rows.map((r) => r.id))
  );
  return {
    selected: games,
    common: games.filter((f) => ids.every((set) => set.has(f.id))),
  };
}
export function comparisonMetrics(games, id, source, perGame = false) {
  const s = historySummary(games, id, source),
    divisor = perGame ? s.count : 1;
  const o = s.outcomes,
    od = perGame ? o?.count : 1;
  return {
    ...s,
    goalsFor: s.count ? s.for / divisor : null,
    goalsAgainst: s.count ? s.against / divisor : null,
    goalTotal: s.count ? (s.for + s.against) / divisor : null,
    goalDifference: s.count ? (s.for - s.against) / divisor : null,
    wins: o ? o.win / od : null,
    draws: o ? o.draw / od : null,
    losses: o ? o.loss / od : null,
    points: o ? o.points / od : null,
    winProbability: o ? o.win / o.count : null,
    drawProbability: o ? o.draw / o.count : null,
    lossProbability: o ? o.loss / o.count : null,
  };
}
export function metricDifference(a, b) {
  return measured(a) && measured(b) ? a - b : null;
}

// Current settings have rates but no historical match outcomes. Archives retain
// their own period: never claim a shared fixture cohort across different seasons.
export function contextualMetrics(data, id, source, venue='all', perGame=true) {
  if (source.startsWith('settings-')) {
    const r=source==='settings-result'?data?.result_teams?.[id]:data?.ranking?.find(r=>r.team_id===Number(id));
    const f=venue==='all'?(measured(r?.for_home)&&measured(r?.for_away)?(r.for_home+r.for_away)/2:null):r?.['for_'+venue];
    const a=venue==='all'?(measured(r?.against_home)&&measured(r?.against_away)?(r.against_home+r.against_away)/2:null):r?.['against_'+venue];
    return {count:null,goalsFor:perGame?f:null,goalsAgainst:perGame?a:null,goalTotal:perGame&&measured(f)&&measured(a)?f+a:null,goalDifference:perGame&&measured(f)&&measured(a)?f-a:null,quotient:measured(f)&&a>0?f/a:null};
  }
  const archive=data?.history?.teams?.find(t=>t.team_id===Number(id))?.sources?.[0];
  const v=venue==='all'?archive?.actual_totals:archive?.actual_scopes?.[venue],n=v?.played;
  const f=venue==='all'?v?.for:v?.goalsScored,a=venue==='all'?v?.against:v?.goalsAgainst,d=perGame?n:1;
  const div=x=>n>0&&measured(x)?x/d:null;
  return {count:n??0,period:archive?`${archive.league_name} · ${archive.season_name}`:null,goalsFor:div(f),goalsAgainst:div(a),goalTotal:measured(f)&&measured(a)?div(f+a):null,goalDifference:measured(f)&&measured(a)?div(f-a):null,quotient:measured(f)&&a>0?f/a:null,wins:div(v?.won),draws:div(v?.draw),losses:div(v?.lost),points:div(v?.points),winProbability:n>0&&measured(v?.won)?v.won/n:null,drawProbability:n>0&&measured(v?.draw)?v.draw/n:null,lossProbability:n>0&&measured(v?.lost)?v.lost/n:null};
}
